"use client";

import type { CopyEntries } from "@/utils/copyUtils";
import { createContext, useContext } from "react";

export type Branding = {
  id: string;
  colour: string;
  logoSmall: string;
  portalName: string;
  merchantId: string;
  supportEmail?: string;
  supportUrl?: string;
  slug: string;
  copyEntries: CopyEntries;
};

const BrandingContext = createContext<Branding | null>(null);

export function BrandingProvider({
  children,
  branding,
}: {
  children: React.ReactNode;
  branding?: Branding;
}) {
  return (
    <BrandingContext.Provider value={branding || null}>
      {children}
    </BrandingContext.Provider>
  );
}

// Hook that guarantees non-null branding data
export function useBranding() {
  const branding = useContext(BrandingContext);

  if (!branding) {
    throw new Error(
      "Branding data is not available. This hook should only be used within [slug] routes.",
    );
  }

  return branding;
}
